import { gql } from '@apollo/client';

export const CONVERSATION_SUBSCRIPTION = gql`
  subscription MessageConversation($identity: [String!]) {
    messageConversation(identity: $identity) {
      id
      direction
      client {
        id
        name
        phoneNumber
        country {
          id
          flag
        }
        profilePicture {
          id
          url
        }
      }
      pinned
      channelId
      conversationStatus
      messageContent
      markAsClosed
      conversationType
      recordingUrl
      friendlyName
      voicemailRecordingUrl
      user {
        name
        isAiAgent
      }
      agent {
        id
        status
        callPlatform
        user {
          id
          name
          email
          phoneNumber
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
          }
        }
        userOnlineManagement {
          id
          userWorkspaceId
          workspaceId
          isActive
          lastSeenAt
          awayTill
          message
          icon
          activeStatus
        }
        workspace {
          id
          label
          status
          trusted
        }
      }
      voicemailRecording {
        id
        url
        duration
        transcription {
          id
          jobStatus
        }
      }
      callRecording {
        id
        url
        duration
        transcription {
          id
          jobStatus
        }
      }
      durationConference {
        id
        startDate
        endDate
      }
      createdAt
      updatedAt
      forwardedAt
      forwardedTo {
        id
        externalNumber
        channel {
          id
          friendlyName
          phoneNumber
        }
      }
      messageConversationErrorLog {
        code
        message
        statusCode
      }
      numMedia
      friendlyName
      markAsBlocked
    }
  }
`;

export const CHANNEL_UNREAD_MESSAGE_COUNT = gql`
  subscription AssignedChannelCounter($identity: [String]) {
    assignedChannelCounter(identity: $identity) {
      counter
      channelId
      clientId
      from
    }
  }
`;

export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription NotificationSubscription {
    notificationSubscription {
      notification {
        id
        createdAt
        updatedAt
        imageUrl
        title
        body
        isExternal
        type
        redirection {
          key
          params {
            memberId
            channelId
            clientId
            clientName
            markAsClosed
            pinned
          }
        }
        replacementAttributes {
          key
          value
        }
        redirectUrl
        seenAt
      }
      counter
      userWorkspaceId
    }
  }
`;

export const CALLER_ID_VERIFICATION_SUBSCRIPTION = gql`
  subscription callerIdVerification {
    callerIdVerification {
      id
      friendlyName
      phoneNumber
      sid
      createdAt
      updatedAt
    }
  }
`;

export const CONTACT_IMPORT_PROGRESS_SUBSCRIPTION = gql`
  subscription ImportBulkContactProgress($eventReferenceId: String) {
    importBulkContactProgress(eventReferenceId: $eventReferenceId) {
      progress
      status
    }
  }
`;

export const WALLET_USAGE_EXPORT_SUBSCRIPTION = gql`
  subscription WalletUsageHistoryExportMedia($identity: String!) {
    walletUsageHistoryExportMedia(identity: $identity) {
      url
      id
    }
  }
`;

export const INVOICE_EXPORT_SUBSCRIPTION = gql`
  subscription ExportInvoicesStatus {
    exportInvoicesStatus {
      status
      data {
        id
        url
      }
    }
  }
`;

export const DIALER_CALL_PULSE_SUBSCRIPTION = gql`
  subscription DialerCallPulse($identity: String!) {
    dialerCallPulse(identity: $identity) {
      feature
      data
    }
  }
`;

export const CALL_FAILED_SUBSCRIPTION = gql`
  subscription MessageConversationErrorLog {
    messageConversationErrorLog {
      id
      message
      code
      statusCode
      workspaceId
      createdAt
    }
  }
`;

export const MEMBER_CONVERSATION_SUBSCRIPTION = gql`
  subscription ChatMessage {
    chatMessage {
      id
      body
      createdAt
      isPinned
      sender {
        id
        status

        user {
          id
          name
          email
          phoneNumber
          emailVerifiedAt

          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
          }
        }

        userOnlineManagement {
          id
          userWorkspaceId
          workspaceId
          isActive
          lastSeenAt
          awayTill
          message
          icon
          activeStatus
          userWorkspace {
            id
            status
          }
        }

        workspace {
          id
          label
          status
          trusted
        }
      }
      room {
        id
      }
      type
      messageConversation {
        id
        conversationStatus
        effectiveStartedAt
        effectiveEndedAt
      }
    }
  }
`;

export const WORKSPACE_MEMBERS_ONLINE_MANAGEMENT_SUBSCRIPTION = gql`
  subscription WorkspaceMembersOnlineManagement {
    workspaceMembersOnlineManagement {
      workspace {
        id
      }
      userWorkspace {
        id
      }
      isActive
      message
      lastSeenAt
      id
      icon
      awayTill
      activeStatus
    }
  }
`;

export const WORKSPACE_RATE_LIMIT = gql`
  subscription WorkspaceRateLimit {
    workspaceRateLimit {
      id
      category
      direction
      threshold
      timeLimit
      segmentLimit
      exhaust {
        value
      }
    }
  }
`;

export const SUBSCRIPTION_WALLET_SUBSCRIPTION = gql`
  subscription walletDetails {
    walletDetails {
      amount
    }
  }
`;

export const SUBSCRIPTION_MESSAGE_SCHEDULE = gql`
  subscription MessageSchedule($identity: [String!]) {
    messageSchedule(identity: $identity) {
      id
      messageContent
      createdAt
      client {
        id
        phoneNumber
        country {
          id
          flag
        }
      }
      channel {
        id
        phoneNumber
        identity
      }
      attachments {
        id
        url
      }
    }
  }
`;

export const SUBSCRIPTION_EXPORT_CONTACTS_SUBSCRIPTION = gql`
  subscription ExportContactStatus {
    exportContactStatus {
      status
      data {
        url
        size
        originalname
        mimetype
        key
        id
      }
    }
  }
`;

export const SUBSCRIPTION_EXPORT_BULK_IMPORT_JOB_ROWS_STATUS = gql`
  subscription ExportBulkImportJobRowsStatus {
    exportBulkImportJobRowsStatus {
      status
      data {
        url
        size
        originalname
        mimetype
        key
        id
      }
    }
  }
`;

export const SUBSCRIPTION_SEND_TRANSCRIPTION_STATUS_SUBSCRIPTION = gql`
  subscription SendTranscriptionStatus {
    sendTranscriptionStatus {
      id
      jobStatus
      providerCallRecordingsId
    }
  }
`;

export const LIVE_CALL_SUBSCRIPTION = gql`
  subscription liveConference {
    liveConference {
      id
      agent {
        callPlatform
        user {
          id
          name
          isAiAgent
          profilePicture {
            id
            url
          }
        }
        userOnlineManagement {
          isActive
        }
      }
      client {
        id
        name
        phoneNumber
        country {
          flag
        }
        profilePicture {
          id
          url
        }
      }
      channel {
        friendlyName
        phoneNumber
        identity
        country {
          flag
        }
      }
      direction
      conversationStatus
      createdAt
      durationConference {
        startDate
      }
    }
  }
`;

export const SUBSCRIPTION_LIVE_CONFERENCE = gql`
  subscription LiveConferenceCountSubscription {
    liveConferenceCount {
      count
      normalCount
      aiCount
    }
  }
`;

export const SUBSCRIPTION_WORKSPACE_COUNT = gql`
  subscription WorkspaceCounter {
    workspaceCounter {
      workspaceId
      to
      from
      counter
      channelId
      userWorkspaceId
    }
  }
`;

export const SUBSCRIPTION_BULK_IMPORT_STATUS = gql`
  subscription BulkImportStatus($jobId: String!) {
    bulkImportStatus(jobId: $jobId) {
      id
      status
      totalRows
      processedRows
      succeededRows
      failedRows
      errorMessage
    }
  }
`;

export const SUBSCRIPTION_KYC_VERIFICATION = gql`
  subscription KycVerificationSession {
    kycVerificationSession {
      id
      status
      workspaceId
    }
  }
`;

export const SUBSCRIPTION_WORKSPACE_MEMBER_NOTIFICATION_COUNTER = gql`
  subscription WorkspaceMemberNotificationCounter {
    workspaceMemberNotificationCounter {
      counter
      memberId
      roomId
      type
      userWorkspaceId
    }
  }
`;

export const SUBSCRIPTION_PAYMENT_ORDER_CREATED = gql`
  subscription PaymentOrderCreated {
    paymentOrderCreated {
      id
      orderNumber
      workspaceId
      userId
      clientRequestId
      batchId
      cartAmount
      chargedAmount
      status
      lienStatus
      type
      remarks
      itemsQuantity
      dunningAttempt
      failureReason
      createdAt
      updatedAt
    }
  }
`;

export const SUBSCRIPTION_EXPORT_SUBSCRIPTION_OVERVIEW_STATUS = gql`
  subscription ExportSubscriptionOverviewStatus {
    exportSubscriptionOverviewStatus {
      status
      data {
        id
        url
        originalname
        size
        key
        mimetype
      }
    }
  }
`;

export const SUBSCRIPTION_AI_AGENT_CALL_TRANSCRIPT = gql`
  subscription AiAgentCallTranscript($messageConversationId: Int!) {
    aiAgentCallTranscript(messageConversationId: $messageConversationId) {
      id
      messageConversationId
      turnIndex
      role
      content
      detectedLanguage
      wasInterrupted
      startedAt
      endedAt
    }
  }
`;
